<script setup>
import {defineEmits, defineProps, ref} from "vue"
import {useRouter} from "vue-router"
import MainModal from "@/components/layouts/MainModal"
import CellBoardRow from "@/components/panels/CellBoardRow.vue"
import {errorNotify} from "@/mixins"

// Only the cell flags are editable: cells and their board addresses come from the device,
// a physical board is swapped through CellBoardRow (replace-board)
const emit = defineEmits(['setCell', 'close', 'changed', 'maintenance'])
const props = defineProps({
  cell: Object,
  canReplaceBoard: { type: Boolean, default: false },
  inMaintenance: { type: Boolean, default: false },
})
const router = useRouter()

const instanceData = ref({
  number: props.cell.number,
  status: props.cell.status,
  active_order: props.cell.active_order,
  cleaning_required: props.cell.cleaning_required,
  is_broken: props.cell.is_broken,
  is_active: props.cell.is_active,
})

function confirm() {
  emit('setCell', instanceData.value)
  emit('close')
}

// out of service cells open CellServiceModal instead (see DevicesDetail.vue openCellModal)
function handleStatusAction() {
  if (instanceData.value.status === 'occupied') {
    openRentalOrder()
  }
  emit('close')
}

function openRentalOrder() {
  if (instanceData.value.active_order) {
    router.push(`/orders/${instanceData.value.active_order}`)
  } else {
    errorNotify({'Error': 'No active order found for this cell'})
  }
}

</script>


<template>
  <main-modal @confirm="confirm()" @cancel="emit('close')">
    <template v-slot:title>Cell {{instanceData.number}}</template>
    
    <!-- read from the parent's cell, not instanceData: a refetch updates address/board_confirmed -->
    <cell-board-row
        class="mb-3"
        :cell="cell"
        :can-replace="canReplaceBoard"
        :in-maintenance="inMaintenance"
        @changed="emit('changed')"
        @maintenance="emit('maintenance')"/>

    <div v-if="instanceData.status === 'occupied'">
      Occupied
    </div>
    
    <div v-else class="modal__content">

      <div class="row py-3">
        <div class="col-6">
          <input v-model="instanceData.cleaning_required" class="form-check-input" type="checkbox" value="" id="cleaningRequired">
          <label class="form-check-label px-2" for="cleaningRequired">
            Cleaning required
          </label>
        </div>
        <div class="col-3">
          <input v-model="instanceData.is_broken" class="form-check-input" type="checkbox" value="" id="isBroken">
          <label class="form-check-label px-2" for="isBroken">
            Broken
          </label>
        </div>
        <div class="col-3">
          <input v-model="instanceData.is_active" class="form-check-input" type="checkbox" value="" id="isActive">
          <label class="form-check-label px-2" for="isActive">
            Active
          </label>
        </div>
      </div>

    </div>

    <!-- Custom actions for specific statuses -->
    <template v-slot:actions v-if="instanceData.status === 'occupied'">
      <div class="row">
        <div class="col">
          <button class="btn btn-secondary w-100" @click="emit('close')">Close</button>
        </div>
        <div class="col">
          <button class="btn btn-warning w-100" @click="handleStatusAction()">
            Open rental order
          </button>
        </div>
      </div>
    </template>
  </main-modal>
</template>
